import React from "react";
import { Div, Text, Button, Row, Col } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import Swiper from "react-id-swiper";
import CreatorsModal from "../../modals/CreatorsModal";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

const params = {
  slidesPerView: 1.2,
  spaceBetween: 10,
  mousewheel: {
    forceToAxis: true,
    invert: true,
  },
  slideOffsetAfter: 60,
};

class InfluencersNetwork extends React.Component {
  state = { showModal: false };

  render() {
    const { title, label, testimonials } = this.props;

    return (
      <WebsiteContainer>
        <CustomContainer p="0">
          <Div
            d={{ lg: "flex", md: "flex", xs: "none" }}
            justify={{ md: "start", lg: "center" }}
            overflow="auto"
            textAlign="center"
            m={{ t: { xs: "8.25rem", md: "14.5rem" } }}
          >
            {testimonials.map((testimonial, index) => {
              return (
                <Div
                  className="creators-testimonial-card"
                  d="flex"
                  flexDir="column"
                  justify="space-between"
                  minW="18.75rem"
                  w="18.75rem"
                  key={index}
                  p={{ t: "2rem" }}
                  m={{ x: ".6rem" }}
                >
                  <Div p={{ x: "1rem" }} m={{b: ".5rem"}}>
                    <Text
                      textColor="black"
                      textSize="subheader5"
                      textWeight="700"
                      m={{ b: ".4rem" }}
                      tag="h3"
                    >
                      {testimonial.user}
                    </Text>
                    <Text fontFamily="secondary" textColor="black">
                      {testimonial.testimonial.testimonial}
                    </Text>
                  </Div>

                  <ImageLink link={testimonial.image.description}>
                    <Div
                      bgImg={testimonial.image.file.url}
                      bgSize="cover"
                      bgPos="top"
                      bgRepeat="no-repeat"
                      p={{ b: { lg: "30rem", md: "25rem" } }}
                      bgPos="center"
                    ></Div>
                  </ImageLink>
                </Div>
              );
            })}
          </Div>
          <Div
            className="influencer-slider-wrapper"
            m={{ t: "6rem" }}
            d={{ md: "none", xs: "block" }}
            textAlign="center"
          >
            <Swiper {...params}>
              {testimonials.map((testimonial, index) => {
                return (
                  <Div
                    //w="85%"
                    d="flex"
                    flexDir="column"
                    justify="space-between"
                    key={index}
                    //bg={testimonial.cardColor || "blueGray"}
                    className="creators-testimonial-card"
                    p={{ t: "1.5rem" }}
                  >
                    <Div p={{x: "1rem"}} m={{b: ".5rem"}}>
                      <Text
                        textColor="black"
                        textSize="subheader5"
                        textWeight="700"
                        m={{ b: ".4rem" }}
                      >
                        {testimonial.user}
                      </Text>
                      <Text fontFamily="secondary" textColor="black">
                        {testimonial.testimonial.testimonial}
                      </Text>
                    </Div>
                    <ImageLink link={testimonial.image.description}>
                      <Div
                        bgImg={testimonial.image.file.url}
                        bgSize="cover"
                        bgPos="top"
                        bgRepeat="no-repeat"
                        p={{ b: "19rem" }}
                      ></Div>
                    </ImageLink>
                  </Div>
                );
              })}
            </Swiper>
          </Div>
        </CustomContainer>
        <CreatorsModal
          isOpen={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
        />
      </WebsiteContainer>
    );
  }
}

export default InfluencersNetwork;
